import { idyuJsonRpc } from "@/assets/js/idyu/connect.js";

async function needsNotify() {
  if (document.hidden === false) return false;
  if ("Notification" in window === false) return false;
  if (Notification.permission === "granted") return true;
  if (Notification.permission === "denied") return false;

  if ((await idyuRequireNotifyPermission()) === false) {
    return false;
  }

  return false;
}

function strip(html) {
  const tmp = document.createElement("DIV");
  tmp.innerHTML = html;
  const res = tmp.textContent || tmp.innerText || "";

  if (res.length >= 50) return res.substr(0, 50) + "...";
  return res;
}

export async function idyuRequireNotifyPermission() {
  const permission = await Notification.requestPermission();

  // Quelque soit la réponse de l'utilisateur, nous nous assurons de stocker cette information
  if (!("permission" in Notification)) {
    Notification.permission = permission;
  }

  // Si l'utilisateur est OK, on crée une notification
  if (permission === "granted") {
    return true;
  }
  return false;
}

export function idyuGetPushMessageOptions(body, idFrom) {
  const options = {
    body: body,
    icon: "img/icons/logo16.png",
    vibrate: [100, 50, 100],
    data: {
      idFrom: idFrom
    }
  };

  return options;
}

export async function idyuNotifyMessage(msg) {
  if (await needsNotify()) {
    const prf = await idyuJsonRpc("getProfileSummary", msg.data.idFrom);

    const options = idyuGetPushMessageOptions(prf.pseudo + " : " + strip(msg.data.message), msg.data.idFrom);
    if ("serviceWorker" in navigator) {
      const reg = await navigator.serviceWorker.getRegistration();
      reg.showNotification("Idylive : nouveau message !", options);
    }
  }
}
